export default __webpack_public_path__ + "static/media/OuterRectangle.547d3323.svg";